module.exports = __webpack_public_path__ + "img/_009.9a0ac728.png";